import { ID, Task } from '@griply/types';

// Inserts the duplicate ids as a contiguous block immediately after the last
// selected original present in `order`, keeping them in the originals' visual
// order. Returns the same array reference when no original is present, so
// callers can cheaply detect "no change".
export const insertDuplicatesAfterSelection = (
  order: ID[],
  pairs: Array<{ oldTask: Task; newTask: Task }>,
): ID[] => {
  const present = pairs
    .map((pair) => ({
      newId: pair.newTask.id,
      index: order.indexOf(pair.oldTask.id),
    }))
    .filter((entry) => entry.index >= 0)
    .sort((a, b) => a.index - b.index);

  if (!present.length) {
    return order;
  }

  const insertAt = present[present.length - 1].index + 1;
  const block = present.map((entry) => entry.newId);
  return [...order.slice(0, insertAt), ...block, ...order.slice(insertAt)];
};
